import { Controller } from "@hotwired/stimulus"
import { get } from '@rails/request.js';

export default class extends Controller {
  static values = { id: Number };
  declare readonly idValue?: number;
  declare readonly hasIdValue: boolean;

  connect() {
  }

  changeType = e => {
    if (!e.target.checked) return;
    const path = this.hasIdValue ? `/admin/parties/${this.idValue}/edit` : '/admin/parties/new';
    const type = e.target.value;
    get(`${path}?type=${type}`, { responseKind: 'turbo-stream' });
  }
}
